import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import * as S from './FormGenerateLists.styles'
import { ProductsList, RestockingListTypesEnum } from '../../RestockingTypes'
import { actions } from '../../RestockingState'
import { useEffect } from 'react'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { useHistory } from 'react-router-dom'
import { fixInputSx } from '../../utils'

interface Props {
  productsList: ProductsList
  shedCode: string[]
  restockingSubType: string
  idRestockingType: number
  shippingDate: string
  idFulfillmentCenterDestination: number
  isValidFcDestination: () => boolean
}

export const FormGenerateLists = ({
  productsList, shedCode, restockingSubType, idRestockingType, shippingDate, idFulfillmentCenterDestination, isValidFcDestination,
}: Props) => {
  const {
    register, getValues, watch, setValue, handleSubmit, formState: { errors },
  } = useForm()

  const history = useHistory()

  const dispatch = useDispatch()

  const { fc, validateFc } = useFulfillmentCenter()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  useEffect(() => {
    if (productsList.totalSkus > 0) {
      setValue('quantityToRestocking', productsList.totalSkus)
    }
  }, [productsList.totalSkus, setValue])

  useEffect(() => {
    setValue('quantityPerPage', '')
    setValue('quantityToRestocking', 0)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idRestockingType])

  const onSubmit = () => {
    if (!isValidFcDestination()) {
      return
    }

    const quantityPerPage = getValues('quantityPerPage')
    const quantityToRestocking = getValues('quantityToRestocking')

    const { products } = productsList

    dispatch(actions.generateRestockingLists({
      history,
      fulfillmentCenterId: fc.id,
      quantityPerPage,
      quantityToRestocking,
      products,
      generatedCode: shedCode,
      sourceType: restockingSubType,
      totalSkus: productsList.totalSkus,
      idType: idRestockingType,
      level: productsList.level,
      priority: productsList.priority,
      shippingDate,
      idFulfillmentCenterDestination,
    }))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <S.Container>
        {idRestockingType === RestockingListTypesEnum.RESTOCKING_FRESH_AUTOMATIC
        && (
        <S.ContainerTotal>
          <p>Total skus: {productsList.totalSkus}</p>
          <p>Total demanda - alta prioridade: {productsList.totalDemandHigh}</p>
          <p>Total demanda - baixa prioridade: {productsList.totalDemandLow}</p>
          <p>Total programada: {productsList.totalProgrammed}</p>
          <p>Total sem capacidade cadastrada: {productsList.totalNoCapacity}</p>
        </S.ContainerTotal>
        )}
        <S.FilterContainer>
          {idRestockingType === RestockingListTypesEnum.RESTOCKING_FRESH_AUTOMATIC
          && (
          <S.CustomTextWrapper>
            <S.CustomTextField
              sx={fixInputSx}
              id='quantityPerPage'
              name='quantityPerPage'
              type='number'
              autoComplete='off'
              inputProps={{
                ...register('quantityPerPage',
                  {
                    required: 'Campo obrigatório',
                    min: { value: 1, message: 'Deve ser um valor positivo' },
                  }),
                'data-testid': 'quantity-per-page-test',
              }}
              error={!!errors.quantityPerPage}
              label='restocking.sku.per.page'
              helperText={errors.quantityPerPage?.message}
              fullWidth
              size='medium'
            />
            <S.CustomTextField
              sx={fixInputSx}
              id='quantityToRestocking'
              name='quantityToRestocking'
              defaultValue={productsList.totalSkus}
              type='number'
              autoComplete='off'
              inputProps={{
                ...register('quantityToRestocking',
                  {
                    required: 'Campo obrigatório',
                    min: { value: 1, message: 'Deve ser um valor positivo' },
                  }),
                'data-testid': 'quantity-to-restocking-test',
              }}
              error={!!errors.quantityToRestocking}
              label='quantity.restocking.sku'
              helperText={errors.quantityToRestocking?.message}
              fullWidth
              InputLabelProps={{ shrink: true }}
              size='medium'
            />
          </S.CustomTextWrapper>
          )}
          <S.CustomButton
            title='Gerar'
            type='submit'
            bgColor='blue'
            hoverColor='darkBlueHover'
            letterColor='white'
            testId='button-generate'
            disabled={!productsList.products?.length}
          />
        </S.FilterContainer>
      </S.Container>
      {idRestockingType === RestockingListTypesEnum.RESTOCKING_FRESH_AUTOMATIC
      && <S.CustomText>Total de páginas geradas: {Math.ceil((watch('quantityToRestocking') || 0) / (watch('quantityPerPage') || 1))}</S.CustomText>}
    </form>
  )
}
